export default __webpack_public_path__ + "static/media/training.14d9e324.svg";